export enum SystemComponentEnum{
    CustomerAccounts = 1,
    BillingManagementNewBilling = 2,
    BillingManagementBillingHistory = 3,
    UsageManagement = 4,
    Tariff = 5,
    RevenuePayment = 6,
    RevenueTransaction= 7,
    AdministratorUserManagement = 8,
    AdministratorRoleManagement = 9,
    AdministratorBillPeriod= 10,
    AdministratorAuditLog= 11,
  
    //CRUD settings page
    TransmissionStation = 12,
    MainFeeder = 13,
    InjectionSubstation= 14,
    SubFeeder = 15,
    DistributionTransformer = 16,
    Region= 17,
    Area= 18,
  
    //Admin pages
    AdminUtilityAccounts = 19,
    AdminUserManagement = 20,
    AdminRoleManagement = 21,
    AdminConfiguration = 22,
  
    ErroneusReadings = 23,
    FailedValidation = 24,
    PreviousBalance = 25,
    OverdueBills = 26,
    ConsumptionAdjustment = 27,
    BillEstimation = 28,
    BillingManagementBillRegularization = 29,
    RebillingPage = 30,
    FraudBillingReport = 31,
    PaymentPlanReport = 32,
    RevenueRecovery = 33,
    FraudBillPaymentHistory = 34,
    DeletedFraudBills = 35,
    RejectedUsages = 36,
    OverdueFraudReport = 37,
    PrepaymentManagement = 38,
    DeviceSetup = 39,
    TokenManagement = 40,
    VendingKeyManagement = 41,
  
  
    CustomerAccountsView = 50101,
    CustomerAccountsAddCustomer = 50102,
    CustomerAccountsUploadNew = 50103,
    CustomerAccountsExport = 50104,
    CustomerAccountsDelete = 50105,
    CustomerAccountsEdit = 50106,
    CustomerAccountsActivation = 50107,
  
    ReadingHistoryView = 50151,
    ReadingHistoryAddRead = 50152,
    ReadingHistoryDownload = 50153,
    ReadingHistoryExport = 50154,
  
    UsageManagementView = 50201,
    UsageManagementRecall = 50202,
    UsageManagementConfirm = 50203,
    UsageManagementReject = 50204,
    UsageManagementUpload = 50205,
    UsageManagementRebill = 50206,
    UsageManagementConfirmAll = 50207,
    UsageManagementAddPreviousBalance = 50208,
  
    FailedValidationView = 50301,
    FailedValidationRebill = 50302,
    FailedValidationAllowBilling = 50303,
  
    RejectedUsagesView = 50351,
    RejectedUsagesExport = 50352,
  
    ErroneusReadingView = 50401,
  
    TariffAdjustmentView = 50501,
    TariffAdjustmentAdjust = 50502,
    TariffAdjustmentApprove = 50503,
    TariffAdjustmentSecondLevelApprove = 50504,
    
    ConsumptionAdjustmentView = 50601,
    ConsumptionAdjustmentAdjust = 50602,
    ConsumptionAdjustmentApprove = 50603,
    ConsumptionAdjustmentDelete = 50604,
    ConsumptionAdjustmentSecondLevelApprove = 50605,
    
    BillEstimationView = 50701,
    BillEstimationExport = 50702,
    BillEstimationEstimate = 50703,
  
    NewBillingView = 50801,
    NewBillingProcessAll = 50802,
    NewBillingProcess = 50803,
    NewBillingDownload = 50804,
    NewBillingIssue = 50805,
    NewBillingRecall = 50806,
  
    BillingHistoryView = 50901,
    BillingHistoryDownload = 50902,
  
    BillRegularizationView = 51101,
    BillRegularizationDownload = 51102,
  
    OverdueBillsView = 51001,
    
    PaymentView = 51201,
    UploadLastPayment = 51202,
    LastPaymentTemplateDownload = 51203,
    DownloadReportPayment = 51204,
    ConfirmPayment = 51205,
    CustomerAccountStatement = 51206,
    RevokePayment = 51207,
    ChangePaymentsCustomer = 51208,
  
    PreviousBalanceView = 51301,
    UploadLastPreviousBalance = 51302,
    ClosingBalanceTemplateDownload = 51303,
  
    TransactionHistoryView = 51401,
    TransactionHistoryDownload = 51402,
  
    TariffView = 51501,
    TariffCreate = 51502,
    TariffEdit = 51503,
    TariffBulkUpload = 51504,
    TariffActivation = 51505,
  
    UserManagementView = 51601,
    UserManagementAdd = 51602,
    UserManagementEdit = 51603,
    UserManagementActivation = 51604,
  
    RoleManagementView = 51701,
    RoleManagementAdd = 51702,
    RoleManagementEdit = 51703,
    RoleManagementActivation = 51704,
  
    BillSettingsView = 51801,
    BillSettingsApply = 51802,
  
    AuditLogView = 51901,
    AuditLogDownload = 51902,
  
    //TS
    CrudTsView = 52001,
    CrudTsAdd = 52002,
    CrudTsEdit = 52003,
    CrudTsDelete = 52004,
    CrudTsUpload = 52005,
  
    //main feeder
    CrudMainFeederView = 52101,
    CrudMainFeederAdd = 52102,
    CrudMainFeederEdit = 52103,
    CrudMainFeederDelete = 52104,
    CrudMainFeederUpload = 52105,
  
    //SS
    CrudSsView = 52201,
    CrudSsAdd = 52202,
    CrudSsEdit = 52203,
    CrudSsDelete = 52204,
    CrudSsUpload = 52205,
  
    //SUB FEEDER
    CrudSubFeederView = 52301,
    CrudSubFeederAdd = 52302,
    CrudSubFeederEdit = 52303,
    CrudSubFeederDelete = 52304,
    CrudSubFeederUpload = 52305,
  
    //DT
    CrudDTView = 52401,
    CrudDTAdd = 52402,
    CrudDTEdit = 52403,
    CrudDTDelete = 52404,
    CrudDTUpload = 52405,
  
    //REGION
    CrudRegionView = 52501,
    CrudRegionAdd = 52502,
    CrudRegionEdit = 52503,
    CrudRegionDelete = 52504,
    CrudRegionUpload = 52505,
  
    //DISTRICT
    CrudDistrictView = 52601,
    CrudDistrictAdd = 52602,
    CrudDistrictEdit = 52603,
    CrudDistrictDelete = 52604,
    CrudDistrictUpload = 52605,
  
    //ROUTRE
    CrudRouteView = 52701,
    CrudRouteAdd = 52702,
    CrudRouteEdit = 52703,
    CrudRouteDelete = 52704,
    CrudRouteUpload = 52705,
  
    //ITINERARY
    CrudItineraryView = 52801,
    CrudItineraryAdd = 52802,
    CrudItineraryEdit = 52803,
    CrudItineraryDelete = 52804,
    CrudItineraryUpload = 52805,
  
    //meter make
    CrudMeterMakeView = 52901,
    CrudMeterMakeAdd = 52902,
    CrudMeterMakeEdit = 52903,
    CrudMeterMakeDelete = 52904,
    CrudMeterMakeUpload = 52905,
  
    //client type
    CrudClientTypeView = 53001,
    CrudClientTypeAdd = 53002,
    CrudClientTypeEdit = 53003,
    CrudClientTypeDelete = 53004,
    CrudClientTypeUpload = 53005,
  
    //Accounts Group
    CrudAccountsGroupView = 53201,
    CrudAccountsGroupAdd = 53202,
    CrudAccountsGroupEdit = 53203,
    CrudAccountsGroupDelete = 53204,
    CrudAccountsGroupUpload = 53205,
  
    //TS
    CrudStaffView = 53501,
    CrudStaffAdd = 53502,
    CrudStaffEdit = 53503,
    CrudStaffDelete = 53504,
    CrudStaffUpload = 53505,
  
    //rebilling page
    RebillingPageView = 53101,
    RebillingPageExport = 53102,
    RebillingPageRebill = 53103,
    RebillingPageApprove = 53104,
    RebillingPageSecondLevelApprove = 53105,
  
    FraudBillingReportView = 53301,
    FraudBillingReportGenerate = 53302,
    FraudBillingApprove = 53303,
    FraudBillingSecondLevelApprove = 53304,
    FraudBillingReportEdit = 53305,
    FraudBillingReportDelete = 53306,
    OverdueFraudView = 53307,
    
    PaymentPlanReportView = 53401,
    PaymentPlanReportCreate = 53402,
    PaymentPlanReportEdit = 53403,
    PaymentPlanReportCancel = 53404,
    PaymentPlanReportDelete = 53405,
  
    GroupedAccountsView = 53601,
    GroupedAccountsAdd = 53602,
    GroupedAccountsRemove = 53603,
    GroupedAccountsDownload = 53604,
    GroupedAccountsExport = 53605,
    GroupedAccountsProcess = 53606,
    GroupedAccountsIssue = 53607,
  
    JobStatusHistoryView = 53701,
  
    FraudBillPaymentHistoryView = 53801,
  
    RecalledView = 53901,
    RecalledExport = 53902,
    RecalledDownload = 53903,
    
    DeletedFraudBillsView = 54001,
  
    EstimationJobHistoryView = 54101,
    EstimationStatusHistoryApply = 54102,
  
    //DeviceSetup
    DeviceSetupView = 54150,
     DeviceSetupAddDevice = 54151,
     VendingManagementView = 54301,
  
    //reports page
    AMRDocketReport = 55001,
    NonAMRDocketReport = 55002,
    AMRSalesReport = 55003,
    KVAReport = 55004,
    DebtReport = 55005,
    SalesReportPerCustomer = 55006,
    DebtAgingReport = 55007,
  
    FixTheBillView = 55101,
    FixTheBillConfirm = 55102,
    FixTheBillReject = 55103,
  
    DebtDashboard = 55201,
    MeterDashboard = 55202
  }